import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f98d88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "item-content" }

import _ from 'lodash';
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = [
  {
    label: '캠페인 소개',
    target: '#page-2'
  },
  {
    label: '캠페인 일정',
    target: '#page-5'
  },
  {
    label: '수거 가이드',
    target: '#page-6'
  },
  {
    label: '원더플 여정',
    target: '#page-9'
  },
  {
    label: 'FAQ',
    target: '#page-faq'
  }
];

const onPageResize = _.debounce(setHeaderHeight, 500);
onMounted(() => {
  setHeaderHeight();
  window.addEventListener('resize', onPageResize);
});

const headerRef = ref<HTMLDivElement>();
function setHeaderHeight() {
  const h = headerRef.value?.offsetHeight;
  document.body.style.setProperty('--cocacola-season-4-navbar-height', `${h}px`);
}

function scrollToTarget(target: string) {
  document.querySelector(target)?.scrollIntoView();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "headerRef",
    ref: headerRef,
    class: "cocacola-navbar"
  }, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
        return _createElementVNode("li", {
          key: item.label,
          onClick: ($event: any) => (scrollToTarget(item.target))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
        ], 8, _hoisted_1)
      }), 64))
    ])
  ], 512))
}
}

})